<div class="view-box">
  <div class="ctent-view">
    <span class="btn-back" (click)="backDetail()"></span>
    <h2 class="tit-feedback">{{ 'User Feedback' | translate }}</h2>
    <ul class="list-question">
      <li *ngFor="let data of datas">
        <h3 class="tit-question">{{ data.section_name | translate }}</h3>
        <ol>
          <li *ngFor="let question of data.questions">{{ question.reply + ' ' + question.t_answer }}</li>
        </ol>
      </li>
    </ul>
  </div>
</div>